import { render } from "./SimpleSelect.vue?vue&type=template&id=1a459230"
import script from "./SimpleSelect.vue?vue&type=script&lang=js"
export * from "./SimpleSelect.vue?vue&type=script&lang=js"

import "./SimpleSelect.vue?vue&type=style&index=0&id=1a459230&lang=scss"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__